var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.list, function(t, i) {
    var m0 = _vm.$getImg(t.cover)
    return {
      $orig: _vm.__get_orig(t),
      m0: m0
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      ;(_vm.setMealShow = true), (_vm.setMealShowUp = true)
    }

    _vm.e1 = function($event) {
      _vm.setMealShow = false
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }